import React from "react";

const RecommendationCard = ({ modalToggle }) => {
  return (
    <div className="saas-card" style={{ justifyContent: "center", alignItems: "center", textAlign: "center", padding: "28px" }}>
      <h3 style={{ fontSize: "1.125rem", fontWeight: 700, color: "#0f172a", marginBottom: "8px" }}>
        WANT TO HELP YOUR TEAMMATES?
      </h3>
      <p style={{ fontSize: "0.875rem", color: "#64748b", lineHeight: "1.5", marginBottom: "20px", maxWidth: "400px" }}>
        We know some of your teammates could really use the help of fans. Tell us which athletes you recommend, and we will alert fans.
      </p>
      <button
        className="saas-btn primary"
        onClick={() => modalToggle("promote")}
        style={{ width: "100%", maxWidth: "260px" }}
      >
        Recommend Teammates
      </button>
    </div>
  );
};

export default RecommendationCard;
